// Instance
import MainAPI from '@/app/apis/main/main-api.js';

// Endpoints
import { API, ENDPOINTS } from '@/app/apis/main/_connection/connection-api.js';

// Query String
const queryString = require('querystring');

class DocumentAPI extends MainAPI {

	/**
	 * Retrieves document details for a given pet and document ID.
	 * @async
	 * @param {string} petId - The ID of the pet associated with the document.
	 * @param {string} documentId - The ID of the document to retrieve details for.
	 * @returns {Promise<object>} A Promise that resolves to an object representing the document details.
	 */
	async getDocumentById(petId, documentId) {
		return API.get(`${ENDPOINTS.GET_DOCUMENT}/${petId}/${documentId}`);
	}


		/**
	 * @return {*} document list
	 */
		async getDocumentLists(documentDetails) {
			return API.get(`${ENDPOINTS.GET_DOCUMENT}?${queryString.stringify(documentDetails)}`);
		}

	/** 
	 * @param {*} docDetails
	 */
	async postDocument(docDetails) {
		let newFormData = new FormData();
		
		newFormData.append(
			'formData',
			JSON.stringify(docDetails.formDetails)
		);
		newFormData.append(
			'document',
			docDetails.document
		);

		return API.post(ENDPOINTS.POST_DOCUMENT, newFormData);
	}

	/**
	 * @param {*} docInfo
	 * @param {*} docId
	 */
	async putDocument(docInfo, docId) {
		return API.put(`${ENDPOINTS.PUT_DOCUMENT}/${docId}`, docInfo);
	}
	/**
	 * @param {*} docInfo
	 * @param {*} docId
	 */
	async deleteDocument(petInfo, docId) {
		return API.delete(`${ENDPOINTS.DELETE_DOCUMENT}/${docId}`, { data: petInfo });
	}
}

export default new DocumentAPI();
